// LEGACY CODE
// Private
function updatePanBlacklists(clickedLink) {
  var binTail = clickedLink.parent().data('bin-tail');
  var selector = '.blacklist-link[data-bin-tail="' + binTail + '"]';
  var linkContainer = $(selector);
  var blacklistLink = linkContainer.find('a');
  var loadingIcon = linkContainer.find('.spinner-image');
  var addBlacklistIcon = linkContainer.find('.add-blacklist-icon');
  var removeBlacklistIcon = linkContainer.find('.remove-blacklist-icon');
  $.ajax({
    beforeSend: function beforeSend() {
      blacklistLink.hide();
      loadingIcon.show();
    },
    success: function success() {
      loadingIcon.hide();
      blacklistLink.show();
      addBlacklistIcon.toggleClass('hidden');
      removeBlacklistIcon.toggleClass('hidden');
    },
    failure: function failure() {
      loadingIcon.hide();
      blacklistLink.show();
    },
    type: clickedLink.data('method'),
    url: clickedLink.attr('href'),
    data: {
      format: 'js'
    }
  });
} // Public


function listenForPaymentTransactionClick() {
  $('.blacklist-link').on('click', 'a', function () {
    var isHidden = $('.remove-blacklist-icon').hasClass('hidden');
    var translation_key = isHidden ? 'add_pan_confirmation' : 'delete_pan_confirmation';

    if (confirm(I18n.t('javascript.' + translation_key))) {
      updatePanBlacklists($(this));
    }

    return false;
  });
} // Is not working


function updateBlacklistOperators() {
  $('#search_name_eq').on('change', function () {
    if ($('#search_name_eq :selected').val() === 'pan') {
      $('#operator option[value="sw"]').remove();
      $('#operator option[value="ew"]').remove();
    } else {
      if ($('#operator option[value="sw"]').length === 0) {
        $('#operator').append(new Option('starts with', 'sw'));
      }

      if ($('#operator option[value="ew"]').length === 0) {
        $('#operator').append(new Option('ends with', 'ew'));
      }
    }

    $('#operator').trigger('chosen:updated');
  });
}

export { updateBlacklistOperators as updateOperatorsOnChange, listenForPaymentTransactionClick };